(function () {
  'use strict';

  if (customElements.get('product-preview-dialog')) return;

  class ProductPreviewDialog extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.trigger = this.querySelector('.tortli-product-preview__trigger');
      this.dialog = this.querySelector('.tortli-product-preview__dialog');
      this.closeButton = this.querySelector('.tortli-product-preview__close');
      this.previewCanvas = this.querySelector('.tortli-product-preview__canvas');
      this.productScope = this.closest('.product') || document;

      if (!this.trigger || !this.dialog || !this.previewCanvas) return;

      this.trigger.addEventListener('click', () => this.open());
      this.closeButton?.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.findPreviewCanvas();
      if (!this.sourceCanvas) {
        this.observer = new MutationObserver(() => this.findPreviewCanvas());
        this.observer.observe(this.productScope, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    findPreviewCanvas() {
      const source = this.productScope.querySelector('.pc-canvas-root .pc-canvas');
      if (!source) return;

      this.sourceCanvas = source;
      this.hidden = false;
      this.observer?.disconnect();
    }

    copyCurrentPreview() {
      // The configurator may replace its canvas after a variant or artwork change.
      // Resolve it again at click time so the popup always shows the current render.
      this.findPreviewCanvas();
      if (!this.sourceCanvas?.isConnected) return false;

      const width = this.sourceCanvas.width || this.sourceCanvas.clientWidth || 1;
      const height = this.sourceCanvas.height || this.sourceCanvas.clientHeight || 1;
      this.previewCanvas.width = width;
      this.previewCanvas.height = height;

      const context = this.previewCanvas.getContext('2d');
      if (!context) return false;
      context.clearRect(0, 0, width, height);
      context.drawImage(this.sourceCanvas, 0, 0, width, height);
      return true;
    }

    open() {
      if (!this.copyCurrentPreview()) return;
      this.dialog.showModal();
    }
  }

  customElements.define('product-preview-dialog', ProductPreviewDialog);
})();
